export const BILLING_DIALOG = 'BILLING_DIALOG';
export const CLEAR_PLAN_SELECTIONS = 'CLEAR_PLAN_SELECTIONS';
export const SELECT_PLAN = 'SELECT_PLAN';
export const SET_SELECTED_PRODUCT_LINE = 'SET_SELECTED_PRODUCT_LINE';
export const SET_BILLING_TYPE = 'SET_BILLING_TYPE';
export const SET_SHOW_ALL_FEATURES = 'SET_SHOW_ALL_FEATURES';
export const UPDATE_BILLING_DIALOG = 'UPDATE_BILLING_DIALOG';
export const UPDATE_PLAN_DIALOG = 'UPDATE_PLAN_DIALOG';
export const HANDLE_ENTERPRISE_CONTACT_US = 'HANDLE_ENTERPRISE_CONTACT_US';
